/**
 * @file Hooks to fetch data using React Query.
 */

import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../constants';

import apiClient from './apiClient';

/**
 * List simulation types.
 */
export const useSimulationTypesQuery = () => {
  return useQuery({
    queryKey: [QueryKeys.SIMULATION_TYPES],
    queryFn: async () => {
      const response = await apiClient.get('/simulation-types/');
      return response.data;
    },
  });
};

/**
 * Get scenario.
 */
export const useScenarioQuery = (scenarioId) => {
  return useQuery({
    queryKey: [QueryKeys.SCENARIOS, scenarioId],
    queryFn: async () => {
      const response = await apiClient.get(`/scenarios/${scenarioId}`);
      return response.data;
    },
    enabled: !!scenarioId,
  });
};

/**
 * List scenarios.
 */
export const useScenarioListQuery = () => {
  return useQuery({
    queryKey: [QueryKeys.SCENARIOS],
    queryFn: async () => {
      const response = await apiClient.get('/scenarios/');
      return response.data;
    },
  });
};

/**
 * Get simulations for a scenario.
 */
export const useSimulationsQuery = (scenarioId) => {
  return useQuery({
    queryKey: [QueryKeys.SIMULATION_RUNS, scenarioId],
    queryFn: async () => {
      const response = await apiClient.get(
        `/scenarios/${scenarioId}/simulation-runs`,
      );
      return response.data;
    },
    enabled: !!scenarioId,
  });
};

/**
 * Get units for a scenario.
 */
export const useScenarioUnitMapQuery = (scenarioId) => {
  return useQuery({
    queryKey: [QueryKeys.SCENARIO_UNIT_MAP, scenarioId],
    queryFn: async () => {
      const response = await apiClient.get(`/scenarios/${scenarioId}/units/`);
      return response.data;
    },
    enabled: !!scenarioId,
  });
};

/**
 * Get patient categories for a scenario.
 */
export const useScenarioPatientCategoryMapQuery = (scenarioId) => {
  return useQuery({
    queryKey: [QueryKeys.SCENARIO_PATIENT_CATEGORY_MAP, scenarioId],
    queryFn: async () => {
      const response = await apiClient.get(
        `/scenarios/${scenarioId}/patient-categories/`,
      );
      return response.data;
    },
    enabled: !!scenarioId,
  });
};

/**
 * List units.
 */
export const useUnitListQuery = () => {
  return useQuery({
    queryKey: [QueryKeys.UNITS],
    queryFn: async () => {
      const response = await apiClient.get('/units/');
      return response.data;
    },
  });
};

/**
 * List patient categories.
 */
export const usePatientCategoryListQuery = () => {
  return useQuery({
    queryKey: [QueryKeys.PATIENT_CATEGORIES],
    queryFn: async () => {
      const response = await apiClient.get('/patient-categories/');
      return response.data;
    },
  });
};
